import React, { Component } from 'react';
import { connect } from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import { T } from 'Actions/translate';
import BasicButton from 'Components/common/BasicButton';
import Anchor from 'Components/common/Anchor';
// Icons
import { ArrowBackIos } from '@material-ui/icons';
import { getAllSkuConditionList, shipmentShip, createInvoicePdf  } from 'Actions/host';
import { openNotification } from 'Actions/notification';

class PackageDetails extends Component {

	state = {
		receiveExitOpened: false,
        f1OrderShipData: [],
        confirmShipData: [],
        currentItem: null,
        currentIndex: 0
	}

    componentWillMount() {
		const packageData = JSON.parse(this.props.match.params.id);
		if (packageData.isReceiveFlag !== undefined && packageData.isReceiveFlag) {
			this.f1OrderReceivePackageCondition(packageData);
		} else {
			this.f1OrderShipPackageCondition(packageData);
		}
	}

	f1OrderReceivePackageCondition = (packageData) => {
        this.props.getAllSkuConditionList({ids: [packageData.productIds]}).then(res => {
            if(res.status === 'success'){
                // let params = {
                //     resData: res.data,
                //     isAllReceive: false,
                //     item: item,
                //     index: index
                // };
                this.openPackageConditionDialog(res.data, packageData);
            }
        });
	}
	
	f1OrderShipPackageCondition = (packageData) => {
		this.setState({
			f1OrderShipData: []
		})
		this.props.getAllSkuConditionList({ids: packageData.productIds}).then(res => {
			if(res.status === 'success'){
				this.showPackageConditionInformation(res.data, packageData.data);
			}
		})
	}

    shipConfirmationHandle = () => {
		const packageData = JSON.parse(this.props.match.params.id);
		if(packageData.isReceiveFlag !== undefined) {
			const receiveBtnsIsLoading = packageData.receiveBtnsIsLoading;
			const productsReceivingQuantity = packageData.productsReceivingQuantity;
			// single Receive
			if (packageData.isReceiveFlag) {
				receiveBtnsIsLoading[this.state.currentIndex] = true;
    
				this.setState({ receiveBtnsIsLoading });
		
				this.props.productsReceive({
					orderId: this.props.match.params.id,
					productQuantity: [{ orderProductId: this.state.currentItem.id, quantity: productsReceivingQuantity[this.state.currentIndex] }]
				}).then(res => {
					this.props.openNotification(T('notification_successful_receipt_of_goods'), 'success');
					this.getOrderDetails();
					receiveBtnsIsLoading[this.state.currentIndex] = false;
					this.setState({ receiveBtnsIsLoading });
				}).catch(res => {
					receiveBtnsIsLoading[this.state.currentIndex] = false;
					this.setState({ receiveBtnsIsLoading });
				})
			} else {// all Receive

			}
		}
        this.props.shipmentShip(packageData.data).then(res => {
            this.props.openNotification(T('notification_successful_delivery'), 'success');
            this.props.createInvoicePdf({ id: res.data }).then(res => {
                if(util.isIOS()) {
                    window.location.href = window.location.origin + '/pdf-preview/pdf-preview.html?url=' + window.encodeURIComponent(`${util.getImageRoot() + res.data}`);
                }
                else {
                    window.open(window.location.origin + '/pdf-preview/pdf-preview.html?url=' + window.encodeURIComponent(`${util.getImageRoot() + res.data}`), '_blank');
                }
				this.props.history.replace('/shipmentList/toBeShip')
            });
        });
	}
 
	openPackageConditionDialog = (data, shipData) => {
		this.setState({
            f1OrderShipData: typeof data !== 'undefined' ? data : [],
            confirmShipData: shipData,
			currentItem: shipData.item,
			currentIndex: shipData.index
        })
	}

	showPackageConditionInformation = (data, shipData) => {
		this.setState({
            f1OrderShipData: typeof data !== 'undefined' ? data : [],
            confirmShipData: shipData
        })
	}

	closeDialog = (name) => {
		this.props.closeDialog(name);
	}

	showConditionContent = (skuReplenishmentDetailData) => {
        return (
			<div className='package-condition-detail' id='packageConditionDetail'>
				<ul className="f1-order-sku-condition-list">
					{
						skuReplenishmentDetailData.length === 0 ? <li className='sku-condition-li'><label className='not-receive-package'>{T('host_receive_not_package_condition')}</label></li> : skuReplenishmentDetailData.map((skuCondition, index) => (
                           <li className='sku-condition-li'>
							   <div className='sku-condition'>
									<div className='sku-condition-detail'>
										<p className='sku-content text-ellipsis sku-style-set'><label>{T('backup_sku')}:</label>{skuCondition.sku}</p>
									</div>
									<div className='storage-condition-detail'>
										<p className='storage-condition-content text-ellipsis'><label>{T('fone_order_storage_condition')}:</label>{skuCondition.storageCondition}</p>
									</div>
									<div className='shipping-condition-detail'>
										<div className='shipping-condition-content text-ellipsis'><label>{T('fone_order_shipping_condition')}:</label>{skuCondition.shippingCondition}</div>
									</div>
									{skuCondition.components !== null ? this.renderSkuKit(skuCondition.components) : null}
							   </div>
						   </li>
						))
					}
				</ul>
			</div>
		);
	}

    renderSkuKit = (skuKitComponents) => {
        return (
			<div className='sku-kit-detail'>
				<div className='sku-kit-content text-ellipsis'>{T('fone_order_kit_detail')}:</div>
				<ul className='sku-kit-list'>
					{
						skuKitComponents.map((skuKitCondition, index) => (
							<li className='sku-kit-li'>
								<div className='sku-kit'>
										<div className='kit-sku-condition-detail'>
											<p className='sku-kit-content text-ellipsis'><label>{T('backup_sku')}:</label>{skuKitCondition.sku}</p>
										</div>
										<div className='kit-storage-condition-detail'>
											<p className='kit-storage-condition-content text-ellipsis'><label>{T('fone_order_storage_condition')}:</label>{skuKitCondition.storageCondition}</p>
										</div>
										<div className='kit-shipping-condition-detail'>
											<div className='kit-shipping-condition-content text-ellipsis'><label>{T('fone_order_shipping_condition')}:</label>{skuKitCondition.shippingCondition}</div>
										</div>
								</div>
							</li>
						))
					}
				</ul>
		    </div>
		);
	}

    goBack = () => {
        this.props.history.goBack();
	}
	
	render() {
		const { isOperateFlag } = this.props;
		const { f1OrderShipData } = this.state;
		return(
            <div className="shipment-details-container">
                <div className="header-wrap">
                    <div className="shipment-details-header container-max-width is-fixed">
                        <Anchor className="go-back" onClickOfSingleTap={ this.goBack }><ArrowBackIos/></Anchor>
                        {T('shippment_inventory_logistics_information')}
                    </div>
                </div>
				
                <div className="content-box">
					{this.showConditionContent(f1OrderShipData)}
				</div>
				<div className="footer-warp">
                    {
                        <div className="shipment-details-footer container-max-width is-fixed">
							<BasicButton className="close-confirm-btn" type="primary" disabled={ false } onClickOfSingleTap={()=>this.shipConfirmationHandle()}>
								<span>{ isOperateFlag === 'receive' ? T('shippment_take_goods') : T('shippment_delivery') }</span>
							</BasicButton>
							<BasicButton className="close-confirm-btn" type="primary" disabled={ false } onClickOfSingleTap={()=>this.goBack()}>
								<span>{ T('shopping_cart_close') }</span>
							</BasicButton>
                        </div>
                    }
                </div>
			</div>
		)
		//  (
		// 	<Dialog dialogDidClose={()=>this.closeDialog('receiveExitOpened')} opened={ opened } options={{ bgClickClose: true }}>
		// 			<div className='logout-dialog'>
		// 				<Grid className='dialog-title' container spacing={0}>
		// 					<Grid item xs={12}>
		// 						<span>{ T('host_receive_package_condition') }</span>
		// 					</Grid>
		// 				</Grid>

		// 				<Grid className='dialog-content shipping-details-dialog-content' container spacing={0} justify={'center'}>
		// 					<Grid item xs={12} className='simple-table-setting'>
		// 						{ this.showConditionContent(skuReplenishmentDetailData) }
		// 					</Grid>
		// 				</Grid>

		// 				<Grid container spacing={0}>
		// 					<Grid item xs={12} align="center">
		// 						<BasicButton className="close-confirm-btn" type="primary" disabled={ false } onClickOfSingleTap={()=>this.shipConfirmationHandle()}>
		// 							<span>{ isOperateFlag === 'receive' ? T('shippment_take_goods') : T('shippment_delivery') }</span>
		// 						</BasicButton>
		// 						<BasicButton className="close-confirm-btn" type="primary" disabled={ false } onClickOfSingleTap={()=>this.closeDialog('receiveExitOpened')}>
		// 							<span>{ T('shopping_cart_close') }</span>
		// 						</BasicButton>
		// 					</Grid>
		// 				</Grid>
		// 			</div>
		// 	</Dialog>
		// )
	}
}


const mapStateToProps = state => {
	const { host } = state;
    return {
		shipmentOrOrderDetails: host.shipmentOrOrderDetails,
		skuReplenishmentDetail: host.skuReplenishmentDetail
	};
};

const mapDispatchToProps = {
    getAllSkuConditionList,
    shipmentShip,
    createInvoicePdf,
    openNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageDetails);
